import TiposDeAtendimentoPage from "@/Pages/DiarioAtendimentos/TiposDeAtendimento/index.vue";
import DiarioAtendimentosEmBrevePage from "@/Pages/DiarioAtendimentos/EmBrevePage.vue";
import AtendimentosIndexPage from "@/Pages/DiarioAtendimentos/Atendimentos/index.vue";
import NewEditAtendimentoPage from "@/Pages/DiarioAtendimentos/Atendimentos/NewEditAtendimentoPage.vue";
import DesenvolvimentoBibliotecaPage from "@/Pages/DiarioAtendimentos/DesenvolvimentoBiblioteca/index.vue";
import FeedbackCoordenacaoPage from "@/Pages/DiarioAtendimentos/FeedbackCoordenacao/index.vue";

export default [
  {
    path: "/diario-atendimentos/tipos",
    name: "diarioAtendimentos.tipos",
    component: TiposDeAtendimentoPage,
  },
  {
    path: "/diario-atendimentos",
    name: "diarioAtendimentos",
    component: AtendimentosIndexPage,
  },
  {
    path: "/diario-atendimentos/atendimentos",
    name: "diarioAtendimentos.atendimentos",
    component: AtendimentosIndexPage,
  },
  {
    path: "/diario-atendimentos/atendimentos/criar",
    name: "diarioAtendimentos.atendimentos.create",
    component: NewEditAtendimentoPage,
    props: { editing: false },
  },
  {
    path: "/diario-atendimentos/atendimentos/editar/:atendimento_id",
    name: "diarioAtendimentos.atendimentos.edit",
    component: NewEditAtendimentoPage,
    props: { editing: true },
  },
  {
    path: "/diario-atendimentos/desenvolvimento-biblioteca",
    name: "diarioAtendimentos.biblioteca",
    component: DesenvolvimentoBibliotecaPage,
  },
  {
    path: "/diario-atendimentos/desenvolvimento-recomposicao",
    name: "diarioAtendimentos.recomposicao",
    component: DiarioAtendimentosEmBrevePage,
    props: { titulo: "Desenvolvimento Recomposição" },
  },
  {
    path: "/diario-atendimentos/feedback-coordenacao",
    name: "diarioAtendimentos.feedback",
    component: FeedbackCoordenacaoPage,
  },
];
